import { render, staticRenderFns } from "./FundaBNPLInsur.vue?vue&type=template&id=ec2fa164&scoped=true&"
import script from "./FundaBNPLInsur.vue?vue&type=script&lang=js&"
export * from "./FundaBNPLInsur.vue?vue&type=script&lang=js&"
import style0 from "./FundaBNPLInsur.vue?vue&type=style&index=0&id=ec2fa164&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2fa164",
  null
  
)

export default component.exports